<template>
    <div id="app">
        <FHeader class="f-header" :title="title"></FHeader>
        <div class="f-body">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="less" scoped>
#app {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    @header-height: 50px;
    .f-header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: @header-height;
    }
    .f-body {
        position: absolute;
        top: @header-height;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        overflow: auto;
    }
}
</style>

<script>
import FHeader from './Header'
export default {
    components: {
        FHeader
    },
    props: {
        title: {
            type: String,
            default: 'Fling'
        },
    }
}
</script>
